<template>
    <form-accordion
        name="home-office"
        section="Home Office Info"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <sales-broker
            :deal="property.deal"
            :broker="broker"
            :read_only="read_only"
        />

        <office-manager
            :contact="contacts_office_manager"
            :read_only="read_only"
        />

        <home-office-coordinator
            :contact="contacts_home_office_coordinator"
            :read_only="read_only"
        />

        <managing-broker
            :contact="contacts_managing_broker"
            :read_only="read_only"
        />

        <transaction-coordinator
            :contact="contacts_transaction_coordinator"
            :read_only="read_only"
        />
    </form-accordion>
</template>

<script>
import SalesBroker from './sales-broker.vue';
import ManagingBroker from './managing-broker.vue';
import OfficeManager from './office-manager.vue';
import TransactionCoordinator from './transaction-coordinator.vue';
import HomeOfficeCoordinator from './home-office-coordinator.vue';

export default {
    components: {
        SalesBroker,
        ManagingBroker,
        OfficeManager,
        TransactionCoordinator,
        HomeOfficeCoordinator,
    },

    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        broker: { default: () => ({}) },
        contacts_home_office_coordinator: { default: () => ({}) },
        contacts_managing_broker: { default: () => ({}) },
        contacts_office_manager: { default: () => ({}) },
        contacts_transaction_coordinator: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
